// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3qGL9","notes":"Notes_notes__2ur5O","note":"Notes_note__24Sa6","markdown":"Notes_markdown__vVQou"};